/* eslint-disable complexity */
import {
  BookWidgetAirport,
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { maxFlightCountForMc } from '../../../constants/common.constants';

export const tripTypeRulesOnInitEval = (
  bookWidgetFields: BookWidgetFields
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    updatedBookWidgetFields.tripTypesField.selectedTripType ===
    TripTypeOptions.MULTI_CITY
  ) {
    if (updatedBookWidgetFields.airportsField.airports.length === 1) {
      const updatedAirports: BookWidgetAirport[] = [
        { ...updatedBookWidgetFields.airportsField.airports[0] }
      ];

      const { toAirportcode = '', toCity = '' } = updatedAirports[0];

      updatedAirports.push({
        fromAirportcode: toAirportcode,
        fromCity: toCity,
        toAirportcode: '',
        toCity: '',
        connectionAirport: '',
        connectionCity: ''
      });

      updatedBookWidgetFields = {
        ...updatedBookWidgetFields,
        airportsField: {
          ...updatedBookWidgetFields.airportsField,
          airports: updatedAirports,
          showAddFlightBtn: updatedAirports.length < maxFlightCountForMc,
          showRemoveFlightBtn: updatedAirports.length > 2
        }
      };
    }

    let updatedDates: SelectedRange[] = [
      ...updatedBookWidgetFields.datesField.dates.map((date) => ({
        start: date.start || null,
        end: null,
        total: 0
      }))
    ];
    if (
      updatedBookWidgetFields.datesField.dates.length <
      updatedBookWidgetFields.airportsField.airports.length
    ) {
      for (
        let i = updatedBookWidgetFields.datesField.dates.length;
        i < updatedBookWidgetFields.airportsField.airports.length;
        i++
      ) {
        updatedDates.push({ start: null, end: null, total: 0 });
      }
    } else {
      updatedDates = updatedBookWidgetFields.datesField.dates.slice(
        0,
        updatedBookWidgetFields.airportsField.airports.length
      );
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      datesField: {
        ...updatedBookWidgetFields.datesField,
        dates: updatedDates
      }
    };
  } else {
    /**
     * This is handling when retrieve search gives MC response, but applying edos selects non mc fields.
     * Here only first entry from airports and dates should be picked, also connected airport should be dropped
     */
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      airportsField: {
        ...updatedBookWidgetFields.airportsField,
        airports: updatedBookWidgetFields.airportsField.airports
          .slice(0, 1)
          .map((airport) => ({
            ...airport,
            connectionAirport: '',
            connectionCity: ''
          })),
        showAddFlightBtn: false,
        showRemoveFlightBtn: false
      },
      datesField: {
        ...updatedBookWidgetFields.datesField,
        dates: updatedBookWidgetFields.datesField.dates.slice(0, 1)
      }
    };

    if (
      updatedBookWidgetFields.tripTypesField.selectedTripType ===
        TripTypeOptions.ONE_WAY &&
      updatedBookWidgetFields.datesField.dates[0]?.end
    ) {
      updatedBookWidgetFields = {
        ...updatedBookWidgetFields,
        datesField: {
          ...updatedBookWidgetFields.datesField,
          dates: [
            {
              start: updatedBookWidgetFields.datesField.dates[0]?.start || null,
              end: null,
              total: 0
            }
          ]
        }
      };
    }
  }

  return updatedBookWidgetFields;
};
